import React, { useState, useEffect} from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import {createCryptoLink, clearCreateCryptoLink } from 'redux/crypto-links/actions';

import CommonSearchDropdownSelector
  from 'components/common/CommonSearchDropdownSelector';
import PlainInput from 'components/elements/inputs/PlainInput';
import Button from 'components/elements/buttons/Button';

import validate from 'components/dashboard/crypto-links-content/validation/validate';

import './AddCryptoLinkForm.css';


function AddCryptoLinkForm(props) {
  const {
    createCryptoLink,
    clearCreateCryptoLink,
    cryptoServicesList,
    createCryptoLinkError,
  } = props;
  const { t } = useTranslation();
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const [inputAddressValue, setInputAddressValue] = useState(null);
  const [inputMemoValue, setInputMemoValue] = useState(null);
  const [addressValidationErrors, setAddressValidationErrors] = useState(null);
  const [memoValidationErrors, setMemoValidationErrors] = useState(null);

  useEffect(() => {
    if (selectedCrypto) {
      setAddressValidationErrors(null);
      setMemoValidationErrors(null);
      clearCreateCryptoLink();
    }
  }, [selectedCrypto]);

  useEffect(() => {
    return () => {
      setSelectedCrypto(null);
      setInputAddressValue(null);
      setInputMemoValue(null);
      setAddressValidationErrors(null);
      setMemoValidationErrors(null);
    };
  }, []);

  function addCryptoLink() {
    if (selectedCrypto.type === 'address_memo' && inputMemoValue) {
      createCryptoLink({
        crypto_service: selectedCrypto.id,
        address: inputAddressValue,
        memo: inputMemoValue,
      });
    } else {
      createCryptoLink({
        crypto_service: selectedCrypto.id,
        address: inputAddressValue,
      });
    }
    setInputAddressValue('');
    setInputMemoValue('');
  }

  function validateCreateCrypto() {
    setAddressValidationErrors(validate(
      cryptoServicesList,
      selectedCrypto.name,
      inputAddressValue,
      addCryptoLink,
    ));
  }

  const itemsList = cryptoServicesList && cryptoServicesList.map(item => ({
    id: item.id,
    type: item.type,
    name: item.name,
    icon_svg: item.icon_svg,
    form_placeholder: item.form_placeholder,
    memo_name: item.memo_name,
  }));

  return (
    <div className="add-crypto-link-form__component">
      <div className="crypto-selector-wrapper">
        <CommonSearchDropdownSelector
          setSelectedItem={setSelectedCrypto}
          itemsList={itemsList}
          searchPlaceholder={t("Select Popular Crypto Currency")}
        />
      </div>

      <div className={`input-field-wrapper${addressValidationErrors ? ' errors' : ''}`}>
        <PlainInput
          key="crypto-address-input-key"
          disabled={!selectedCrypto}
          placeholder={(selectedCrypto && selectedCrypto.form_placeholder)
            || t("Add your Crypto Address here")}
          value={inputAddressValue}
          onChange={e => {
            setInputAddressValue(e.target.value);
            if (addressValidationErrors) {
              setAddressValidationErrors(null);
            }
          }}
          errors={addressValidationErrors}
        />
      </div>

      {selectedCrypto && selectedCrypto.type === 'address_memo' &&
        <div className={`input-field-wrapper${memoValidationErrors ? ' errors' : ''}`}>
          <PlainInput
            key="crypto-memo-input-key"
            disabled={!selectedCrypto}
            placeholder={(selectedCrypto && selectedCrypto.memo_name) || 'MEMO'}
            value={inputMemoValue}
            onChange={e => {
              setInputMemoValue(e.target.value);
              if (memoValidationErrors) {
                setMemoValidationErrors(null);
              }
            }}
            errors={memoValidationErrors}
          />
        </div>
      }

      <div className="buttons-block">
        <Button
          onClick={validateCreateCrypto}
          disabled={!inputAddressValue}
        >
          {`+ ${t("Add")} ${selectedCrypto ? selectedCrypto.name : t("Crypto")} ${t("Address")}`}
        </Button>
      </div>
    </div>
  );
}

AddCryptoLinkForm.propTypes = {
  createCryptoLink: PropTypes.func.isRequired,
  clearCreateCryptoLink: PropTypes.func.isRequired,
  cryptoServicesList: PropTypes.arrayOf(PropTypes.shape),
  createCryptoLinkError: PropTypes.object,
};

AddCryptoLinkForm.defaultProps = {
  cryptoServicesList: null,
  createCryptoLinkError: null,
};

const mapStateToProps = state => (
  {
    cryptoServicesList: state.cryptoLinksReducer.cryptoServicesList,
    createCryptoLinkError: state.cryptoLinksReducer.createCryptoLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    createCryptoLink,
    clearCreateCryptoLink,
  },
)(AddCryptoLinkForm);
